// extracted by mini-css-extract-plugin
export var lightFont = "calculator-module--light-font--KCadf";
export var indent1 = "calculator-module--indent1--x4puK";
export var inputGroup = "calculator-module--input-group--leKAN";
export var stoneLabel = "calculator-module--stone-label--Cdp5V";
export var stoneInput = "calculator-module--stone-input--rO0Ca";
export var timeInput = "calculator-module--time-input--v0Z4Z";
export var timeLabel = "calculator-module--time-label--Ql9HE";
export var presetButton = "calculator-module--preset-button--fiOCL";
export var inputError = "calculator-module--input-error--DZVbN";
export var footnote = "calculator-module--footnote--4N5f9";